import React from "react";
import { cn } from "../utils";

export function PageSection({ children, className }) {
  return <div className={cn("space-y-5", className)}>{children}</div>;
}

export function Grid2({ children, className }) {
  return <div className={cn("grid grid-cols-1 lg:grid-cols-2 gap-4", className)}>{children}</div>;
}
